// extracted by mini-css-extract-plugin
module.exports = {"horizontal-group":"cd01fbf7b5--horizontal-group--pefCW","vertical-group":"cd01fbf7b5--vertical-group--zi1Aj"};